// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"0f9dca5e","205":"2863cc5a","241":"51120bab","480":"89eee76b"}[chunkId] + ".chunk.js";
};